import Hero from "../components/landing/Hero";
import HowItWorks from "../components/landing/HowItWorks";
import SchoolsInquiry from "../components/landing/SchoolsInquiry";

export default function Home() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <SchoolsInquiry />
    </>
  );
}
